import { CertificateProgramEngagement } from '@mc/api'

type Props = {
  notice: CertificateProgramEngagement['notice']
}

export const EngagementNotice = ({ notice }: Props) => (
  <div className='c-bg-base-300 mc-corners--lg c-p-5'>
    <h2 className='c-body-bold c-mb-1'>{notice?.headline}</h2>
    <p className='mc-text-small c-text-color--tint-3'>{notice?.description}</p>
  </div>
)
